import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormGroupModule } from '../../chords/form-group/form-group.module';
import { ActionButtonModule } from '../../notes/action-button/action-button.module';
import { ButtonModule } from '../../notes/button/button.module';
import { DatagridModule } from '../../notes/datagrid/datagrid.module';
import { IconModule } from '../../notes/icon/icon.module';
import { MessageBannerModule } from '../../notes/message-banner/message-banner.module';
import { ModalModule } from '../../notes/modal/modal.module';
import { PaginatorModule } from '../../notes/paginator/paginator.module';
import { TabsModule } from '../../notes/tabs/tabs.module';
import { ReconcileHtmlLinkModule } from '../../shared/directives/reconcile-html-link/reconcile-html-link.module';
import { DigitalDataModule } from '../../shared/modules/digital-data/digital-data.module';
import { SafeHtmlPipeModule } from '../../shared/modules/safe-html/safe-html.module';
import { ListViewExportErrorModalComponent } from './list-view-export-error-modal/list-view-export-error-modal.component';
import { ListViewFiltersFormComponent } from './list-view-filters-form/list-view-filters-form.component';
import { ListViewMobileFiltersComponent } from './list-view-mobile-filters/list-view-mobile-filters.component';
import { ListViewComponent } from './list-view.component';

@NgModule({
  declarations: [
    ListViewComponent,
    ListViewMobileFiltersComponent,
    ListViewExportErrorModalComponent,
    ListViewFiltersFormComponent,
  ],
  imports: [
    CommonModule,
    ActionButtonModule,
    ButtonModule,
    DatagridModule,
    DigitalDataModule,
    IconModule,
    FormGroupModule,
    MessageBannerModule,
    ModalModule,
    PaginatorModule,
    ReconcileHtmlLinkModule,
    TabsModule,
    SafeHtmlPipeModule,
  ],
  exports: [ListViewComponent],
})
export class ListViewModule {}
